import { FC } from 'react'
import { GRAY_600 } from 'constants/styling/theme'
import { MUIInputField } from 'components/common/MUIInputField'
import SearchIcon from '@mui/icons-material/Search'
import { useTranslation } from 'react-i18next'

interface Props {
  value: string
  onChange: (value: string) => void
}

/** Search field that filters the conversation list by participant name / title. */
export const ConversationSearchBar: FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation(['chat'])

  return (
    <MUIInputField
      value={value}
      placeholder={t('chat:search.placeholder')}
      startIcon={<SearchIcon sx={{ fontSize: '2rem', color: GRAY_600 }} />}
      onChange={(event) => onChange(event.target.value)}
    />
  )
}
